import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, IonList } from '@ionic/angular';
import { Patient } from 'src/app/model/patient.model';
import { PatientsService } from 'src/app/services/patients.service';
import { ToastService } from 'src/app/services/toast.service';


@Component({
  selector: 'app-patients-list',
  templateUrl: './patients-list.component.html',
  styleUrls: ['./patients-list.component.scss'],
})
export class PatientsListComponent implements OnInit {
  @ViewChild('patientsList') patientsList: IonList;

  @Input() patients: Patient[] = [];
  @Output() patientDeleted = new EventEmitter<string>();

  constructor(
    private patientsService: PatientsService,
    private toastService: ToastService,
    private alertControl: AlertController,
    private router: Router) { }

  ngOnInit() {}

  view(patient: Patient) {
    this.patientsList.closeSlidingItems();
    const navigationExtras: NavigationExtras = {
      state: {
        selectedPatient: patient
      }
    };
    this.router.navigate(['home/patients/patient'], navigationExtras);
  }

  delete(patient: Patient) {
    this.patientsList.closeSlidingItems();
    this.patientDeleted.emit(patient.id);
  }

  createNewPatient() {
    this.router.navigate(['home/patients/patient']);
  }

}
